import { render, staticRenderFns } from "./beforetime.vue?vue&type=template&id=13d45618&scoped=true"
import script from "./beforetime.vue?vue&type=script&lang=js"
export * from "./beforetime.vue?vue&type=script&lang=js"
import style0 from "./beforetime.vue?vue&type=style&index=0&id=13d45618&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d45618",
  null
  
)

export default component.exports